import { routePage, TRoutePage } from './route-page';
import { tabName } from 'src/app/infrastructure/services/page-services/models/tab-name';
import { TabName } from 'src/app/infrastructure/services/page-services/models/tab-name';

// Voor pagina's die 1-op-1 onder een vaste tab van hun (vaste, niet dubbel-context) ouder hangen:
// welke tab moet die ouder tonen wanneer hij alleen vóór DEZE navigatie gesynthetiseerd wordt
// (NavigationStackService.enter(), de "ontbrekende voorouders aanvullen"-tak)? Zonder deze koppeling
// toont een gesynthetiseerde ouder altijd zijn eerste tab, ongeacht welk kind de aanleiding was — bv.
// terug vanuit Activity (rechtstreeks vanaf een andere pagina geopend, AdminPanel dus nooit écht
// bezocht op deze stack) toonde AdminPanel's Functions-tab i.p.v. Activities.
//
// Alleen invullen waar de doel-tab ondubbelzinnig vaststaat — dus niet voor routePage.page, dat zowel
// op de Pages- als de Tabs-tab kan landen, afhankelijk van het Kind van het record.
export const pageParentTab: Partial<Record<TRoutePage, TabName>> = {
    [routePage.adminActivity]: tabName.activities,
    [routePage.adminClaim]: tabName.claims,
    [routePage.adminClaimAction]: tabName.claimActions,
    [routePage.adminCreditType]: tabName.creditTypes,
    [routePage.adminDomainUser]: tabName.domainUsers,
    [routePage.adminFunction]: tabName.functions,
    [routePage.adminPageComponent]: tabName.pageComponents,
    [routePage.adminRole]: tabName.roles,
    [routePage.theme]: tabName.themes,
};
